export const errorPageTranslationKeys = {
  errorPage404Title: 'error-page.404-title',
  errorPage404Description: 'error-page.404-description',
  errorPage500Title: 'error-page.500-title',
  errorPage500Description: 'error-page.500-description',
  errorPageButtonReload: 'error-page.button-reload',
  errorPageButtonPreviousPage: 'error-page.button-previous',
  errorPageButtonGoToHomePage: 'error-page.button-go-to-home',
}
